import { OP_SEARCH_ITEMS, TP_SEARCH_ITEMS } from './searchItems';

// 雇用形態
export const EMPLOYMENT_VALUES = [
  {
    id: '1',
    value: OP_SEARCH_ITEMS.regularEmployee.id,
  },
  {
    id: '2',
    value: OP_SEARCH_ITEMS.contractEmployee.id,
  },
  {
    id: '3',
    value: OP_SEARCH_ITEMS.other.id,
  },
] as const;

// 休日・働き方
export const HOLIDAY_AND_WAY_OF_WORKING_VALUE = [
  {
    id: '1',
    value: OP_SEARCH_ITEMS.fiveDayWorkweekSystem.id,
  },
  {
    id: '2',
    value: OP_SEARCH_ITEMS.MoreThan120DaysOffAYear.id,
  },
  {
    id: '3',
    value: OP_SEARCH_ITEMS.holiday.id,
  },
  {
    id: '4',
    value: OP_SEARCH_ITEMS.consecutiveVacations.id,
  },
  {
    id: '5',
    value: OP_SEARCH_ITEMS.noOvertime.id,
  },
  {
    id: '6',
    value: OP_SEARCH_ITEMS.littleOvertime.id,
  },
  {
    id: '7',
    value: OP_SEARCH_ITEMS.flexibleWork.id,
  },
  {
    id: '8',
    value: OP_SEARCH_ITEMS.maternityAndChildcareLeave.id,
  },
] as const;

// 募集・採用情報
export const REQUIREMENT_VALUES = [
  {
    id: '1',
    value: OP_SEARCH_ITEMS.inexperiencedOccupationWelcome.id,
  },
  {
    id: '2',
    value: OP_SEARCH_ITEMS.IndustryInexperiencedWelcome.id,
  },
  {
    id: '3',
    value: OP_SEARCH_ITEMS.noAcademicBackgroundRequired.id,
  },
  {
    id: '4',
    value: OP_SEARCH_ITEMS.noTransfer.id,
  },
  {
    id: '5',
    value: OP_SEARCH_ITEMS.secondTimeGraduate.id,
  },
  {
    id: '6',
    value: OP_SEARCH_ITEMS.expert.id,
  },
  {
    id: '7',
    value: OP_SEARCH_ITEMS.urgentRecruit.id,
  },
  {
    id: '8',
    value: OP_SEARCH_ITEMS.employsManyPeople.id,
  },
  {
    id: '9',
    value: OP_SEARCH_ITEMS.noChangeInJobTitle.id,
  },
] as const;

// 会社・職場の環境
export const WORKPLACE_ENVIRONMENT_VALUE = [
  {
    id: '1',
    value: OP_SEARCH_ITEMS.listedCompany.id,
  },
  {
    id: '2',
    value: OP_SEARCH_ITEMS.foreignCompany.id,
  },
  {
    id: '3',
    value: OP_SEARCH_ITEMS.fewerRetirees.id,
  },
  {
    id: '4',
    value: OP_SEARCH_ITEMS.femaleThriving.id,
  },
  {
    id: '5',
    value: OP_SEARCH_ITEMS.commutingByCar.id,
  },
  {
    id: '6',
    value: OP_SEARCH_ITEMS.freeDressCode.id,
  },
] as const;

// 待遇・福利厚生
export const BENEFITS_VALUE = [
  {
    id: '1',
    value: OP_SEARCH_ITEMS.retirementBenefitPlan.id,
  },
  {
    id: '2',
    value: OP_SEARCH_ITEMS.companyHousingAndEentSubsidySystem.id,
  },
  {
    id: '3',
    value: OP_SEARCH_ITEMS.childcareAndChildcareSupportSystem.id,
  },
  {
    id: '4',
    value: OP_SEARCH_ITEMS.qualificationAcquisitionSupportSystem.id,
  },
  {
    id: '5',
    value: OP_SEARCH_ITEMS.fullTrainingSystem.id,
  },
  {
    id: '6',
    value: OP_SEARCH_ITEMS.salaryOf250kYenMore.id,
  },
  {
    id: '7',
    value: OP_SEARCH_ITEMS.salaryOf350kYenMore.id,
  },
  {
    id: '8',
    value: OP_SEARCH_ITEMS.UIturnSupport.id,
  },
] as const;

// 語学
export const LANGUAGE_VALUE = [
  {
    id: '1',
    value: OP_SEARCH_ITEMS.english.id,
  },
  {
    id: '2',
    value: OP_SEARCH_ITEMS.chinese.id,
  },
] as const;

// 仕事内容
export const POSITIONS_VALUE = [
  {
    id: '1',
    value: OP_SEARCH_ITEMS.overseasBusinessTrip.id,
  },
  {
    id: '2',
    value: OP_SEARCH_ITEMS.manager.id,
  },
] as const;

// 社員の平均年齢
export const AVERAGE_AGE_VALUE = [
  {
    id: '1',
    value: OP_SEARCH_ITEMS.twenties.id,
  },
  {
    id: '2',
    value: OP_SEARCH_ITEMS.thirties.id,
  },
  {
    id: '3',
    value: OP_SEARCH_ITEMS.forties.id,
  },
  {
    id: '4',
    value: OP_SEARCH_ITEMS.overFifties.id,
  },
] as const;

// 年収下限
export const LOWER_LIMIT_INCOME_VALUES = [
  { id: '1', value: '20' },
  { id: '2', value: '25' },
  { id: '3', value: '30' },
  { id: '4', value: '35' },
  { id: '5', value: '40' },
  { id: '6', value: '45' },
  { id: '7', value: '50' },
  { id: '8', value: '55' },
  { id: '9', value: '60' },
  { id: '10', value: '65' },
  { id: '11', value: '70' },
  { id: '12', value: '80' },
  { id: '13', value: '90' },
  { id: '14', value: '100' },
] as const;

// 年収上限
export const UPPER_LIMIT_INCOME_VALUES = [
  { id: '1', value: '20' },
  { id: '2', value: '25' },
  { id: '3', value: '30' },
  { id: '4', value: '35' },
  { id: '5', value: '40' },
  { id: '6', value: '45' },
  { id: '7', value: '50' },
  { id: '8', value: '55' },
  { id: '9', value: '60' },
  { id: '10', value: '65' },
  { id: '11', value: '70' },
  { id: '12', value: '80' },
  { id: '13', value: '90' },
  { id: '14', value: '100' },
] as const;

// 求人種別
export const JOB_OFFER_KIND_VALUE = [
  {
    id: '1',
    value: TP_SEARCH_ITEMS.agentServices.id,
  },
  {
    id: '2',
    value: TP_SEARCH_ITEMS.directApplication.id,
  },
] as const;
